"use strict";

/**
* Текущая веб-страница.
* Предоставляет инструменты для работы с текущей веб-страницой.
* Например, позволяет обновить страницу проводника веб-доступа, закрыть страницу, открыть в новом окне.
*
* @namespace WebAccess.current.window
* @since 5.0.0.7300
*
* @example
* WebAccess.current.window.bind('onAfterClose', function(parentWindow) { parentWindow.console.log('afterclose');} );
*/

/**
 * Событие срабатывает до закрытия текущей страницы.
 * @event WebAccess.current.window#beforeclose
 *
 * @example
 * // Проверка изменения веб-страницы. Если веб-страница изменена, открывается окно с подтвержением о выходе со страницы.
 * WA.CR.window.bind('beforeClose', function() { if(SerializeForm() != g_prevFormVal) {return true;} } );
 */

/**
 * Событие срабатывает после закрытия текущей страницы.
 * Срабатывает либо на текущей странице либо на предыдущей странице, с которой была открыта текущая.
 * Работа события зависит от настроек браузера.
 *
 * @event WebAccess.current.window#afterClose
 *
 * @example
 *
 * // Оповещение о закрытии текущей страницы.
 * WA.CR.window.bind('afterClose', function(parentWindow) { parentWindow.console.log('afterclose');} );
 */

(function (global) {
  var Window = BaseObject.extend({
    className: 'Window',
    name: '',
    url: null,
    _isOnBeforeCloseExecuted: false,
    _closeCheckerTimeoutHandlers: {},

    init: function () {
      this._super();
      this.name = window.name;
      this.url = new WA.URL();
      this._isOnBeforeCloseExecuted = false;
      this._closeCheckerTimeoutHandlers = {};
    },

    /**
    * Привязать функцию к событию.
    *
    * @method WebAccess.current.window.bind
    * @param {string} name Имя события
    * @param {function} fuc Функция-обработчик
    * @since 5.0.0.7300
    * @return {WebAccess.current.window} Объект типа window.
    */
    bind: function (name, func) {
      var me = this;
      var nameLowered = name.toLowerCase();
      if (nameLowered === 'beforeclose') {
        me._bindOnBeforeClose(name, func);
      } else if (nameLowered === 'afterclose') {
        // Событие срабатывает на закрытие окна.
        me._bindOnAfterClose(name, func);
      } else {
        me._super(name, func);
      }
      return me;
    },

    /**
    * Привязать функциию к событию BeforeClose.
    *
    * @method WebAccess.current.window._bindOnBeforeClose
    * @since 5.0.0.7300
    * @return {WebAccess.current.window} Объект типа window.
    * @private
    */
    _bindOnBeforeClose: function (name, func) {
      var me = this;
      window.onbeforeunload = function (e) {
        if (me._isOnBeforeCloseExecuted) return;
        try {
          e = e || window.event;

          var msg = '';
          if ($.isFunction(func)) {
            msg = func();
          }

          if (msg && msg !== false) {
            // Этот флаг исправляет баг FF, в котором окно появеляется дважды.
            me._isOnBeforeCloseExecuted = true;
            setTimeout(function () { me._isOnBeforeCloseExecuted = false; }, 10);
            // For IE and Firefox
            if (e) {
              e.returnValue = msg;
            }
            // хитрость чтобы скрыть спиннер если пользователь нажмет отмену
            setTimeout(function () {
              setTimeout(function () {
                HideTopSpinner();
              }, 1000);
            }, 1);
            // For Safari
            return msg;
          }
        }
        catch (ex) {
          log.warning('WINDOW', ex);
        }
      };

      return me;
    },

    /**
    * Привязать функцию к событию AfterClose.
    *
    * @method WebAccess.current.window._bindOnAfterClose
    * @since 5.0.0.7300
    * @return {WebAccess.current.window}
    * @private
    */
    _bindOnAfterClose: function (name, func) {
      var me = this;
      var opener = me._getWindowOpener();
      if (opener && !opener.closed) {
        // Навешиваем событие на родительское окно, т.к. это окно закроется, то некому будет выполнить это событие.
        if (opener.WebAccess) opener.WebAccess.current.window._startWindowCloseChecker(window, opener.cloneFunction(func));
      } else {
        window.onunload = function () {
          me._runCallbackIfClose(window, func);
        };
      }
      return me;
    },

    /**
    * Удалить функцию, привязанную к событию.
    *
    * @method WebAccess.current.window.unbind
    * @param {string} name Имя события
    * @return {WebAccess.current.window} Объект типа window.
    * @since 5.0.0.7300
    */
    unbind: function (name) {
      var nameLowered = name.toLowerCase();
      if (nameLowered === 'beforeclose') {
        this._unbindOnBeforeClose(name);
      } else if (nameLowered === 'afterclose') {
        this._unbindOnAfterClose(name);
      } else {
        this._super(name);
      }
    },

    /**
    * Удаление привязонной функции к событию BeforeClose.
    *
    * @method WebAccess.current.window._unbindOnBeforeClose
    * @param {string} name Имя события
    * @return {WebAccess.current.window}
    * @private
    * @since 5.0.0.7300
    */
    _unbindOnBeforeClose: function (name, func) {
      window.onbeforeunload = null;
    },

    /**
    * Удаление привязонной функции к событию AfterClose.
    *
    * @method WebAccess.current.window._unbindOnBeforeClose
    * @param {string} name Имя события
    * @return {WebAccess.current.window}
    * @private
    * @since 5.0.0.7300
    */
    _unbindOnAfterClose: function (name) {
      var opener = this._getWindowOpener();
      if (opener && !opener.closed) {
        opener.WebAccess.current.window._clearAndDeleteCloseCheckerTimeoutHandler(window.name);
      } else {
        window.onunload = null;
      }
    },

    /**
    * Получает родительское окно.
    *
    * @method WebAccess.current.window._getWindowOpener
    * @return {window}
    * @private
    * @since 5.0.0.7300
    */
    _getWindowOpener: function () {
      try { //IE9 может ругаться
        if (window.opener) {
          // Если открыт грид в iframe, то его можно обновлять после закрытия вкладки.
          if (window.opener.location.href.toLowerCase().indexOf('/referencerecords.aspx?') === -1 && window.opener.frameElement) {
            //Открыто из iframe.
            return window.opener.parent;
          } else {
            //Открыто из обычного окна.
            return window.opener;
          }
        }
      } catch (e) {
        log.warning('WINDOW', e);
      }
      return null;
    },

    /**
    * Запускает таймер на родительской странице, который следит за закрытием окна.
    *
    * @method WebAccess.current.window._startWindowCloseChecker
    * @return {WebAccess.current.window}
    * @private
    * @since 5.0.0.7300
    */
    _startWindowCloseChecker(childWindow, onCloseFunc) {
      let childWindowName = childWindow.name;
      this._clearAndDeleteCloseCheckerTimeoutHandler(childWindowName);
      this._closeCheckerTimeoutHandlers[childWindowName] = setTimeout(() => {
        if (childWindow.closed) {
          this._clearAndDeleteCloseCheckerTimeoutHandler(childWindowName);
          this._runCallbackIfClose(childWindow, onCloseFunc);
        } else {
          this._startWindowCloseChecker(childWindow, onCloseFunc);
        }
      }, 2500);
      return this;
    },

    /**
    * Удаляет таймер на родительской странице, который следит за закрытием окна.
    *
    * @method WebAccess.current.window._clearAndDeleteCloseCheckerTimeoutHandler
    * @return {WebAccess.current.window}
    * @private
    * @since 5.0.0.7300
    */
    _clearAndDeleteCloseCheckerTimeoutHandler: function (name) {
      var me = this;
      if (!!me._closeCheckerTimeoutHandlers[name]) {
        try {
          clearTimeout(me._closeCheckerTimeoutHandlers[name]);
        } catch (e) { }
        try {
          delete me._closeCheckerTimeoutHandlers[name];
        } catch (e) { }
      }
      return me;
    },

    /**
    * Запускает callback после закрытия окна.
    *
    * @method WebAccess.current.window._runCallbackIfClose
    * @return {WebAccess.current.window}
    * @private
    * @since 5.0.0.7300
    */
    _runCallbackIfClose: function (childWindow, onCloseFunc) {
      var me = this;
      setTimeout(function () {
        if (childWindow.closed) {
          if (window.NeedUpdateOnChildClose) {
            if (WA.getLocation() === 'referencerecords' && window.Core.grid.reference && window.Core.grid.reference.reloadData) {
              window.Core.grid.reference.reloadData();
            } else {
              me.updateExplorerContent();
            }
          }
          if ($.isFunction(onCloseFunc)) {
            onCloseFunc.apply(window, [window]);
          } else {
            //Нужен что бы функция onCloseFunc выполнилась в родительском окне. Это не происходит из-за замыкания на закрытой странице переменной в onCloseFunc.
            eval(onCloseFunc);
          }
        }
      }, 10);
      return me;
    },

    /**
    * Закрыть текущую страницу.
    *
    * @method WebAccess.current.window.close
    * @since 5.0.0.7300
    */
    close: function () {
      var browser = WA.ENV.browser;
      if ((window.opener && window.opener.WA) || $.ipad) {
        window.close();
      } else {
        location.href = "/explorer.aspx";
      }
    },

    /**
    * Обновить текущую страницу.
    *
    * @method WebAccess.current.window.reload
    * @since 5.0.0.7300
    */
    reload: function () {
      window.location.reload();
    },

    /**
    * Открыть проводник веб-доступа в текущем окне.
    *
    * @method WebAccess.current.window.openExplorer
    * @since 5.0.0.7300
    */
    openExplorer: function () {
      window.location = '';
    },

    /**
    * Открыть страницу входа на сайт веб-доступа.
    *
    * @method WebAccess.current.window.openLogin
    * @since 5.0.0.7300
    */
    openLogin: function () {
      try {
        window.location.href = 'Login.aspx?ReturnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);
      } catch (e) {
        log.warning('WINDOW', e);
      }
    },

    /**
    * Обновить страницу проводника веб-доступа.
    *
    * @method WebAccess.current.window.reloadExplorer
    * @return {WebAccess.current.window} Объект типа window.
    * @since 5.0.0.7300
    */
    reloadExplorer: function () {
      if (WA.getLocation() === 'explorer') {
        var jLikeFilter = $('#FastSearch');
        var predefinedFilters = $('#predefined_filters');

        var likeFilterValue = '';
        if (jLikeFilter.length > 0 && jLikeFilter.val() != '') {
          likeFilterValue = jLikeFilter.val();
        }

        if (likeFilterValue !== '' || (predefinedFilters.length > 0 && predefinedFilters.data('predefinedselectedfilter') !== '')) {
          setTimeout(function () {
            FilterEDMSContent(regionID, likeFilterValue, $("#QFilter input[id*='FilterVariantsNoLoc']").val());
          }, 500);
          WA.CR.folderTree.update();
        } else {
          var list = $('.object_contents.auto_load');
          if (list.length) {
            var scroller = list.parents('#main_container');
            var scrollTop;
            if ($.scrollActive) {
              scrollTop = scroller.offset().top - list.offset().top;
            } else {
              scrollTop = scroller.scrollTop();
            }
            var count = $('>.folder_item', list).length;
            $.cookie('load_count', count);
            $.cookie('load_scroll', scrollTop);
          }
          window.location.reload();
        }
      }
      return this;
    },

    /**
    * Обновить страницу проводника веб-доступа в родительском окне.
    *
    * @method WebAccess.current.window.reloadParentExplorer
    * @return {WebAccess.current.window} Объект типа window.
    * @since 5.0.0.7300
    */
    reloadParentExplorer: function () {
      try {
        var w = window;
        if (w.opener != null && w.opener.location.href.toLowerCase().search('mode=search') < 0 && w.opener.WebAccess != null) {
          w.opener.WebAccess.current.window.reloadExplorer();
        }
      } catch (e) {
        log.warning('WINDOW', e);
      };
      return this;
    },


    /**
    * Обновить страницу, содержащую список записей справочника, в родительском окне.
    *
    * @method WebAccess.current.window.reloadParentGrid
    * @return {WebAccess.current.window} Объект типа window.
    * @since 5.0.0.7300
    */
    reloadParentGrid: function () {
      try {
        var w = window;
        if (w.opener != null && w.opener.Core.grid.reference && w.opener.Core.grid.reference.reloadData) {
          w.opener.Core.grid.reference.reloadData();
        }
      } catch (e) {
        log.warning('WINDOW', e);
      };
      return this;
    },


    /**
     * Обновить страницу проводника веб-доступа в родительском окне в момент закрытия текущей страницы.
     *
     * @method WebAccess.current.window.reloadParentWindowOnClose
     * @return {WebAccess.current.window} Объект типа window.
     * @since 5.0.0.7300
     */
    reloadParentWindowOnClose: function () {
      try {
        var op = window.opener;
        if (op != null) {
          var formChanged = false;
          if (!!op && !!op.g_prevFormVal && !!op.SerializeForm) {
            formChanged = (op.g_prevFormVal != op.SerializeForm());
          }
          op.NeedUpdateOnChildClose = !formChanged && op.location.href.toLowerCase().search('mode=search') < 0;
        }

      }
      catch (e) {
        log.warning('WINDOW', e);
      }
      return this;
    },

    /**
     * Обновить содержимое проводника.
     *
     * @method WebAccess.current.window.updateExplorerContent
     * @returns {WebAccess.current.window} Объект типа window.
     * @since 5.4.0.1013
     */
    updateExplorerContent: function () {
      if (WA.getLocation() === 'explorer') {
        if (WA.CR.objectList)
          WA.CR.objectList.reload();
      }

      return this;
    },

    /**
     * Обновить содержимое проводника в родительском окне.
     *
     * @method WebAccess.current.window.updateParentExplorerContent
     * @returns {WebAccess.current.window} Объект типа window.
     * @since 5.4.0.1013
     */
    updateParentExplorerContent: function () {
      try {
        var w = window;
        if (w.opener != null && w.opener.location.href.toLowerCase().search('mode=search') < 0 && w.opener.WebAccess != null) {
          w.opener.WebAccess.current.window.updateExplorerContent();
        }
      } catch (e) {
        log.warning('WINDOW', e);
      };
      return this;
    }
  });

  global.window = new Window();
})(window.WebAccess.current);
